import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "37",
  height: "37",
  fill: "#FFCC31"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<path fill-rule=\"evenodd\" stroke=\"#000\" stroke-linecap=\"round\" d=\"M36 18.5C36 28.166 28.166 36 18.5 36S1 28.166 1 18.5C1 8.835 8.834 1 18.5 1S36 8.835 36 18.5Z\" clip-rule=\"evenodd\"></path><path fill=\"#fff\" fill-rule=\"evenodd\" d=\"m14.815 27.71 9.211-9.21z\" clip-rule=\"evenodd\"></path><path stroke=\"#171717\" stroke-linecap=\"round\" stroke-width=\"2\" d=\"m14.815 27.71 9.211-9.21\"></path><path fill=\"#fff\" fill-rule=\"evenodd\" d=\"m14.815 9.29 9.211 9.21z\" clip-rule=\"evenodd\"></path><path stroke=\"#171717\" stroke-linecap=\"round\" stroke-width=\"2\" d=\"m14.815 9.29 9.211 9.21\"></path>", 5)
  ]))]))
}
export default { render: render }